import types from "resources/types";
import { mutateResourceQuery } from "queries";

export const update = (id, data) =>
  mutateResourceQuery(
    types.JOB_WORKERS,
    {
      url: `/api/v2/job_workers/${id}/`,
      options: {
        method: "PATCH",
      },
    },
    data,
    id,
  );
